module.exports = __webpack_public_path__ + "fonts/StdKaiXHYL3EG-Md.ttf";